module.exports = __webpack_public_path__ + "assets/img/news_32_logo3.18a1d107.png";